import React from 'react'
import styled from 'styled-components'

import { EditableTableCell, EditableCellStyledComponentsType } from './EditableTableCell'
import { getPropertyFromColumn } from './utils'

import column from './interface'

interface TableCellProps {
  row: {
    [key: string]: number | string | boolean
  }
  column: column
  rowIndex: number
  accessibilityMode: boolean
}

const EditableTd = styled.td`
  padding: 2px 8px 2px 8px !important;
`
const EditableInput = styled.input`
  width: 60px;
  height: 27px;
  vertical-align: middle;
  outline: none;
  background-color: white !important;
`
const StyledTableRow = styled.td`
  vertical-align: middle !important;
`
const editableComponents: EditableCellStyledComponentsType = {
  EditableTd,
  EditableInput,
}

export const TableCell: React.FC<TableCellProps> = ({ row, column, rowIndex, accessibilityMode }) => {
  const value = getPropertyFromColumn(row, column)
  const justify = column.justify || 'start'
  if (column.isEditable) {
    // extract all editable table cell info from column if isEditable
    const { startInEditMode, isValidSubmission, validKeysRegExp, inputProperties, submit } = column
    return (
      <EditableTableCell
        justify={justify}
        value={value}
        validKeysRegExp={validKeysRegExp}
        submit={submit}
        startInEditMode={startInEditMode}
        isValidSubmission={isValidSubmission}
        inputProperties={inputProperties}
        editableComponents={editableComponents}
        row={row}
      />
    )
  }

  // for ARIA, first item in row must be rowheader
  const role = rowIndex === 0 && !accessibilityMode ? 'rowheader' : undefined

  if (column.customComponent) {
    const {
      customComponent: { comp: Comp, props },
    } = column

    return (
      <StyledTableRow role={role}>
        <div className={`display-flex justify-content-${justify}`}>
          <Comp row={row} column={column} {...props} />
        </div>
      </StyledTableRow>
    )
  }
  return (
    <StyledTableRow role={role}>
      <div className={`cb-padding-left-8 cb-padding-right-8 display-flex justify-content-${justify}`}>{value}</div>
    </StyledTableRow>
  )
}
